import { Pagination } from './Pagination';

export enum NotificationAudience {
  USER = 'USER',
  CUSTOMER = 'CUSTOMER',
}

export enum NotificationChannel {
  IN_APP = 'IN_APP',
  EMAIL = 'EMAIL',
  WHATSAPP = 'WHATSAPP',
}

export enum UserNotificationType {
  SERVICE_REMINDER = 'SERVICE_REMINDER',
  CHECK_PAYABLE_SOON = 'CHECK_PAYABLE_SOON',
  CHECK_PAYABLE_NOW = 'CHECK_PAYABLE_NOW',
  CHECK_PRESENTATION_DEADLINE_SOON = 'CHECK_PRESENTATION_DEADLINE_SOON',
  CHECK_PRESENTATION_DEADLINE_PASSED = 'CHECK_PRESENTATION_DEADLINE_PASSED',
}

export interface UserNotificationAction {
  kind: string;
  entityId: string;
}

export interface UserNotification {
  id: string;
  companyId: string;
  recipientId: string;
  audience: NotificationAudience.USER;
  channel: NotificationChannel.IN_APP;
  type: UserNotificationType;
  read: boolean;
  createdAt: string;
  eventDate: string;
  data: Record<string, string>;
  action?: UserNotificationAction;
}

export interface UserNotificationPaginated
  extends Pagination<UserNotification> {
  prevPage: number | null;
  nextPage: number | null;
}

export interface UserNotificationUnreadCount {
  count: number;
}
